import React from "react";
import withStyles from "isomorphic-style-loader/withStyles";
import s from "./HeroBanner.css";
import heroImg from "/public/SiteImages/large_no_image.png";
import history from "../../core/history";

function HeroBanner() {
  const handleCtaClick = () => {
    history.push("/become-a-host?mode=new");
  };

  const handleMoreInfoClick = (e) => {
    e.preventDefault();
    const target = document.getElementById("por-que-eslipin");
    if (target) {
      target.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section className={s["eh-hero"]}>
      <div className={s["eh-hero__container"]}>
        {/* Left Column: Text Content */}
        <div className={s["eh-hero__content"]}>
          <span className={s["eh-hero__badge"]}>CONVIÉRTETE EN ANFITRIÓN</span>

          <h1 className={s["eh-hero__title"]}>
            Tu propiedad puede<br />
            generar ingresos<br />
            <span className={s["eh-hero__highlight"]}>desde hoy.</span>
          </h1>

          <p className={s["eh-hero__description"]}>
            Publica gratis, recibe pagos seguros y administra tus reservas desde una plataforma diseñada para Bolivia.
          </p>

          <div className={s["eh-hero__actions"]}>
            <button
              type="button"
              className={s["eh-hero__btn"]}
              onClick={handleCtaClick}
            >
              Conviértete en anfitrión
            </button>

            <a
              href="#por-que-eslipin"
              className={s["eh-hero__link-more"]}
              onClick={handleMoreInfoClick}
            >
              Más información
              <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15.4388 17.561L0.439564 2.56193C0.158115 2.28048 0 1.89876 0 1.50074C0 1.10272 0.158115 0.721001 0.439564 0.439557C0.721008 0.158113 1.10273 7.84596e-09 1.50076 0C1.89878 -7.84596e-09 2.28051 0.158113 2.56196 0.439557L16.5 14.3793L30.438 0.439557C30.7195 0.158113 31.1012 0 31.4992 0C31.8973 0 32.279 0.158113 32.5604 0.439557C32.8419 0.721001 33 1.10272 33 1.50074C33 1.89876 32.8419 2.28048 32.5604 2.56193L17.5612 17.561C17.4219 17.7005 17.2565 17.8111 17.0744 17.8866C16.8923 17.9621 16.6971 18.0009 16.5 18.0009C16.3029 18.0009 16.1077 17.9621 15.9256 17.8866C15.7435 17.8111 15.5781 17.7005 15.4388 17.561ZM17.5612 32.5601L32.5604 17.561C32.8419 17.2796 33 16.8978 33 16.4998C33 16.1018 32.8419 15.7201 32.5604 15.4386C32.279 15.1572 31.8973 14.9991 31.4992 14.9991C31.1012 14.9991 30.7195 15.1572 30.438 15.4386L16.5 29.3784L2.56196 15.4386C2.28051 15.1572 1.89878 14.9991 1.50076 14.9991C1.10273 14.9991 0.721008 15.1572 0.439564 15.4386C0.158115 15.7201 0 16.1018 0 16.4998C0 16.8978 0.158115 17.2796 0.439564 17.561L15.4388 32.5601C15.5781 32.6996 15.7435 32.8102 15.9256 32.8857C16.1077 32.9612 16.3029 33 16.5 33C16.6971 33 16.8923 32.9612 17.0744 32.8857C17.2565 32.8102 17.4219 32.6996 17.5612 32.5601Z" fill="#009CFF"/>
</svg>

            </a>
          </div>
        </div>

        {/* Right Column: Hero Image with Arch */}
        <div className={s["eh-hero__media"]}>
          <img
            src={heroImg}
            alt="Tu propiedad puede generar ingresos con Eslipin"
            className={s["eh-hero__img"]}
          />
        </div>
      </div>
    </section>
  );
}

export default withStyles(s)(HeroBanner);

